import { useState, useEffect } from 'react';
import api from '../../Services/api';
import './home.css';
import { Link } from 'react-router-dom';

function Home() {
  const [filme, setFilmes] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function loadFilmes() {
      const response = await api.get("movie/now_playing", {
        params: {
          api_key: "51fbcb314004a461c9dae6099bbc6134",
          language: "pt-BR",
          page: 1,
        },
      });

      setFilmes(response.data.results.slice(0, 20));
      setLoading(false);
    }

    loadFilmes();
  }, []);

  if (loading) {
    return (
      <div className='loading'>
        <h2>Carregando filmes...</h2>
      </div>
    );
  }

  return (
    <div className ='container'>
      
      <div className='titulo-principal'>
        <h1>Filmes em Cartaz</h1>
      </div>

      <div className = 'lista-filmes'>
        {filme.map((filme) => {
          return (
            <article key={filme.id}>
              <strong className='titulo'>{filme.title}</strong>
              <img
                src={`https://image.tmdb.org/t/p/w500${filme.poster_path}`}
                alt={filme.title}
              />
              <p>{filme.overview}</p>
              <Link to={`../filme/${filme.id}`} className='detalhes'>
                Ver Detalhes
              </Link>
            </article>
          );
        })}

      </div>
    </div>
  );
}

export default Home;
